<div data-testid="fandc-generator-fandc-generator-container" class="fandc-generator-container">
  <dx-scroll-view data-testid="fandc-generator-scroll-view" #scrollView>
        <div class="fandc-generator-content">
          <dx-form data-testid="form"
            id="form"
            class="cards-wide"
            [formData]="fandCRequestData"
            [showValidationSummary]="true"
            validationGroup="formGroup"
            (onFieldDataChanged)="onFormDataChanged($event)"
          >
            <dxi-item itemType="group"
                      cssClass="dx-widget"
                      [colCount]="3"
                      labelMode="static">
              <!-- Show SelectBox when no metadata, otherwise show plain text -->
              <ng-container *ngIf="!taskGenerationMetadata">
                <dxi-item itemType="group" [colSpan]="1" [colCount]="10">
                  <dxi-item labelMode="static"
                            dataField="loanNumber"
                            editorType="dxSelectBox"
                            [colSpan]="7"
                            [editorOptions]="{
                    items: (filteredLoanData$ | async) || [],
                    displayExpr: 'name',
                    required: 'true',
                    searchMode: 'contains',
                    searchEnabled: true,
                    itemTemplate: loanItemTemplate
                    }">
                    <dxo-label text="Loan Number"> </dxo-label>
                    <dxi-validation-rule type="required"
                                         message="Loan Number is required">
                    </dxi-validation-rule>
                  </dxi-item>

                  <dxi-item
                    editorType="dxCheckBox"
                    [colSpan]="3"
                    [label]="{ visible: false}"
                    cssClass="loan-checkbox-center-align small-font"
                    [editorOptions]="{ text: activeLoanCheckboxText , onValueChanged: onShowInactiveLoansChanged, value: false}"
                  >
                  </dxi-item>
                </dxi-item>
              </ng-container>

              <!-- Show plain text when metadata is present -->
              <ng-container *ngIf="taskGenerationMetadata">
                <dxi-item editorType="dxTextBox"
                          [colSpan]="1"
                          cssClass="loan-number-readonly"
                          [editorOptions]="readonlyLoanNumberEditorOptions">
                  <dxo-label text="Loan Number"></dxo-label>
                </dxi-item>
              </ng-container>

              <dxi-item labelMode="static"
                  dataField="selectedTemplateType"
                        editorType="dxSelectBox"
                  [colSpan]="1"
                        [editorOptions]="templateTypeEditorOptions">
                <dxo-label text="Type"> </dxo-label>
                <dxi-validation-rule type="required" message="Type is required">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="category"
                        editorType="dxSelectBox"
                        [colSpan]="1"
                        cssClass="dx-widget"
                        [visible]="false"
                        [editorOptions]="templateEditorOptions">
                <dxo-label text="Template"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Template is required">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="frequency"
                        editorType="dxSelectBox"
                  [colSpan]="1"
                        cssClass="dx-widget"
                        [editorOptions]="frequencyEditorOptions">
                <dxo-label text="Frequency"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Frequency needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <!-- Show dropdown for non-One-Time frequencies -->
              <dxi-item labelMode="static"
                        dataField="frequencyOffsetOption"
                        editorType="dxSelectBox"
                        [colSpan]="1"
                        cssClass="dx-widget"
                        [visible]="selectedFrequency !== 'One-Time'"
                        [editorOptions]="frequencyOffsetEditorOptions">
                <dxo-label text="Due"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Due needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <!-- Show date selector for One-Time frequency -->
              <dxi-item labelMode="static"
                        dataField="oneTimeDueDate"
                        editorType="dxDateBox"
                        [colSpan]="1"
                        cssClass="dx-widget"
                        [visible]="selectedFrequency === 'One-Time'"
                        [editorOptions]="oneTimeDueDateOptions">
                <dxo-label text="Due Date"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Due date needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="format"
                        editorType="dxSelectBox"
                  [colSpan]="1"
                        cssClass="dx-widget"
                        [editorOptions]="formatEditorOptions">
                <dxo-label text="Format"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Format needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="reportEntity"
                        editorType="dxSelectBox"
                  [colSpan]="1"
                        cssClass="dx-widget"
                        [editorOptions]="reportEntityOptions">
                <dxo-label text="Report Entity"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Report entity needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="entityName"
                        editorType="dxSelectBox"
                  [colSpan]="1"
                        cssClass="dx-widget"
                        [editorOptions]="customEntityNameOptions">
                <dxo-label text="Entity Name"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Entity name needs to be selected">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        dataField="referenceDate"
                        editorType="dxDateBox"
                  [colSpan]="1"
                        [editorOptions]="referenceDateOptions">
                <dxo-label text="Start Date"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="Start Date is required">
                </dxi-validation-rule>
              </dxi-item>
              <dxi-item labelMode="static"
                        dataField="maturityDate"
                        editorType="dxDateBox"
                  [colSpan]="1"

                        [editorOptions]="maturityDateOptions">
                <dxo-label text="End Date"> </dxo-label>
                <dxi-validation-rule type="required"
                                     message="End Date is required">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item labelMode="static"
                        [colSpan]="2"
                        editorType="dxTagBox"
                        cssClass="dx-widget"
                        [editorOptions]="defaultTasksEditorOptions">
                <dxo-label text="Tasks to be created"> </dxo-label>
              </dxi-item>

              <dxi-item
                data-testid="fandc-generator-reviewer-select"
                labelMode="static"
                [colSpan]="1"
                cssClass="dx-widget"
                editorType="dxSelectBox"
                [editorOptions]="reviewerEditorOptions">
                <dxo-label text="Reviewer"></dxo-label>
              </dxi-item>
              <dxi-item cssClass="user-button mt-2"
                        [colSpan]="3"
                        horizontalAlignment="right"
                        editorType="dxButton"
                        [editorOptions]="{
                  text: 'Generate',
                  useSubmitBehavior: false,
                  validationGroup: 'formGroup',
                  cssClass: 'user-button mb-1 mt-1',
                  horizontalAlignment: 'right',
                  onClick: addPrototypeTasks.bind(this),
                  disabled: !isTaskTypesSelected
                }"></dxi-item>

            </dxi-item>
          </dx-form>



    <div *ngIf="selectedPrototypeTasks && selectedPrototypeTasks.length > 0">
          <dx-data-grid data-testid="fandc-generator-data-grid"
            *ngIf="isDesktopView"
            class="compact-grid-font"
            #prototypeTasksGrid
            [dataSource]="selectedPrototypeTasks"
                [keyExpr]="'rowId'"
                [showBorders]="true"
            [editing]="{ mode: 'cell', allowUpdating: true }"
            (onRowUpdated)="onPrototypeRowUpdated($event)"
            (onRowPrepared)="onPrototypeRowPrepared($event)"
            (onExporting)="onExporting($event)"
            [export]="{ enabled: true, allowExportSelectedData: false }"
          >
            <!-- Grab-friendly horizontal scrolling is a DESKTOP-ONLY affordance
               (>= 1024px): simulated scrolling lets users drag/swipe the content
               area to scroll the many columns, with an always-visible, draggable
               scrollbar. A drag threshold preserves cell click/edit.

               Explicit per-column [width] (not columnMinWidth) is required to
               reliably force overflow: DevExtreme always stretches columns to
               fill 100% of the available container width whenever there is
               leftover space, even with columnMinWidth/columnAutoWidth set --
               those only act as a floor during that stretch computation, they
               never disable it. That is why an earlier columnMinWidth-only fix
               still failed to overflow (and therefore had nothing to
               drag-scroll) on typical desktop-width viewports; only when every
               column has a fixed width does DevExtreme stop redistributing
               space and size the table to the true sum of column widths. -->
            <dxo-scrolling mode="standard" [showScrollbar]="gridDragScrollEnabled ? 'always' : 'onScroll'" [useNative]="!gridDragScrollEnabled" [scrollByContent]="gridDragScrollEnabled" [scrollByThumb]="gridDragScrollEnabled"></dxo-scrolling>
          <!-- Add these three elements to enable filtering -->
          <dxo-header-filter [visible]="true"></dxo-header-filter>


            <dxo-export [enabled]="true"></dxo-export>


            <!-- For each column, you can also specify filter-specific options -->
            <dxi-column dataField="type" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="category" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="frequency" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="due" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="taskName" caption="Document Name" [allowFiltering]="true"></dxi-column>
            <dxi-column dataField="format" [allowFiltering]="true"></dxi-column>
            <dxi-column
              dataField="citation"
              caption="Citation"
              [width]="150"
              [allowEditing]="true"
            ></dxi-column>
            <dxi-column
              dataField="notes"
              caption="Notes"
              [width]="180"
              [allowEditing]="true"
            ></dxi-column>
            <dxi-column
              dataField="referenceDate"
              caption="Start Date"
              [width]="120"
              [allowEditing]="false"
              dataType="date"
              format="MM/dd/yyyy"
            ></dxi-column>
            <dxi-column
              dataField="firstDueDate"
              caption="First Due"
              [width]="120"
              [allowEditing]="true"
              dataType="date"
              format="MM/dd/yyyy"
            ></dxi-column>

            <dxi-column dataField="reportEntityLabel" caption="Report Entity" [width]="150"></dxi-column>
            <dxi-column dataField="entityName" caption="Entity Name" [width]="150"></dxi-column>
            <dxi-column
              dataField="reference"
              caption="Reference"
              [width]="120"
              [allowEditing]="false"
            ></dxi-column>
            <dxi-column
              type="buttons"
              caption="Actions"
              [width]="90"
              [buttons]="[
                {
                  hint: 'Delete',
                  icon: 'trash',
                  onClick: deletePrototypeTask
                }
              ]">
            </dxi-column>
          </dx-data-grid>

          <!-- Mobile (< 1024px) card view: the prototype grid is hidden entirely
               and rows are presented as vertically-stacked cards with no
               horizontal overflow. Editable fields (citation, notes, first due)
               and delete reuse the same store update path as the desktop grid. -->
          <div
            *ngIf="!isDesktopView"
            class="fandc-card-list"
            data-testid="fandc-generator-prototype-card-list"
            role="list"
          >
            <div
              class="fandc-card"
              *ngFor="let task of selectedPrototypeTasks; let i = index"
              [attr.data-testid]="'fandc-generator-prototype-card-item'"
              role="listitem"
            >
              <div class="fandc-card__header">
                <span class="fandc-card__title" [title]="task.taskName">{{ task.taskName || 'Task' }}</span>
                <dx-button
                  data-testid="fandc-generator-prototype-card-delete"
                  icon="trash"
                  stylingMode="text"
                  hint="Delete"
                  [elementAttr]="{ 'aria-label': 'Delete ' + (task.taskName || 'task') }"
                  (onClick)="onPrototypeCardDelete(task)"
                ></dx-button>
              </div>
              <dl class="fandc-card__body">
                <div class="fandc-card__field" *ngIf="task.type">
                  <dt class="fandc-card__label">Type</dt>
                  <dd class="fandc-card__value">{{ task.type }}</dd>
                </div>
                <div class="fandc-card__field" *ngIf="task.category">
                  <dt class="fandc-card__label">Category</dt>
                  <dd class="fandc-card__value">{{ task.category }}</dd>
                </div>
                <div class="fandc-card__field" *ngIf="task.frequency">
                  <dt class="fandc-card__label">Frequency</dt>
                  <dd class="fandc-card__value">{{ task.frequency }}</dd>
                </div>
                <div class="fandc-card__field" *ngIf="task.due">
                  <dt class="fandc-card__label">Due</dt>
                  <dd class="fandc-card__value">{{ task.due }}</dd>
                </div>
                <div class="fandc-card__field" *ngIf="task.format">
                  <dt class="fandc-card__label">Format</dt>
                  <dd class="fandc-card__value">{{ task.format }}</dd>
                </div>
                <div class="fandc-card__field" *ngIf="task.referenceDate">
                  <dt class="fandc-card__label">Start Date</dt>
                  <dd class="fandc-card__value">{{ task.referenceDate | date: 'MM/dd/yyyy' }}</dd>
                </div>
                <div class="fandc-card__field" *ngIf="task.reportEntityLabel">
                  <dt class="fandc-card__label">Report Entity</dt>
                  <dd class="fandc-card__value">{{ task.reportEntityLabel }}</dd>
                </div>
                <div class="fandc-card__field" *ngIf="task.entityName">
                  <dt class="fandc-card__label">Entity Name</dt>
                  <dd class="fandc-card__value">{{ task.entityName }}</dd>
                </div>
                <div class="fandc-card__field" *ngIf="task.reference">
                  <dt class="fandc-card__label">Reference</dt>
                  <dd class="fandc-card__value">{{ task.reference }}</dd>
                </div>
                <div class="fandc-card__field fandc-card__field--editor">
                  <dt class="fandc-card__label">First Due</dt>
                  <dd class="fandc-card__value">
                    <dx-date-box
                      class="fandc-card__editor"
                      data-testid="fandc-generator-prototype-card-firstdue"
                      [(value)]="task.firstDueDate"
                      displayFormat="MM/dd/yyyy"
                      [elementAttr]="{ 'aria-label': 'First due date' }"
                      (onValueChanged)="onPrototypeCardFieldChanged(task)"
                    ></dx-date-box>
                  </dd>
                </div>
                <div class="fandc-card__field fandc-card__field--editor">
                  <dt class="fandc-card__label">Citation</dt>
                  <dd class="fandc-card__value">
                    <dx-text-box
                      class="fandc-card__editor"
                      data-testid="fandc-generator-prototype-card-citation"
                      [(value)]="task.citation"
                      [elementAttr]="{ 'aria-label': 'Citation' }"
                      (onValueChanged)="onPrototypeCardFieldChanged(task)"
                    ></dx-text-box>
                  </dd>
                </div>
                <div class="fandc-card__field fandc-card__field--editor">
                  <dt class="fandc-card__label">Notes</dt>
                  <dd class="fandc-card__value">
                    <dx-text-box
                      class="fandc-card__editor"
                      data-testid="fandc-generator-prototype-card-notes"
                      [(value)]="task.notes"
                      [elementAttr]="{ 'aria-label': 'Notes' }"
                      (onValueChanged)="onPrototypeCardFieldChanged(task)"
                    ></dx-text-box>
                  </dd>
                </div>
              </dl>
            </div>
          </div>

          <div data-testid="fandc-generator-action-buttons" class="action-buttons">
            <dx-form data-testid="fandc-generator-form">
              <dxi-item
                [colSpan]="1"
                cssClass="user-button detail-submit mb-1 mt-1"
                horizontalAlignment="right"
                editorType="dxButton"
                [editorOptions]="{
                  text: 'Preview tasks',
                  useSubmitBehavior: false,
                  validationGroup: 'formGroup',
                  cssClass: 'user-button mb-1 mt-1',
                  horizontalAlignment: 'right',
                  onClick: generateTasks.bind(this)
                }"
              ></dxi-item>
            </dx-form>
          </div>
    </div>

    <div
      *ngIf="generatedTasks && generatedTasks.length > 0"
      #generatedTasksElement
    >

          <div style="font-weight: bold">Previewed tasks</div>
          <dx-data-grid data-testid="fandc-generator-data-grid-1"
            *ngIf="isDesktopView"
            [dataSource]="generatedTasks"
            [showBorders]="true"
            (onRowUpdated)="onGeneratedTaskRowUpdated($event)"
          >
            <!-- Grab-friendly horizontal scrolling, desktop-only (see prototype grid
                 above for the full rationale). Explicit per-column [width] (not
                 columnMinWidth) is required so DevExtreme stops stretching columns
                 to fill the container and this grid overflows/drag-scrolls whenever
                 its natural column widths exceed the available viewport. -->
            <dxo-scrolling mode="standard" [showScrollbar]="gridDragScrollEnabled ? 'always' : 'onScroll'" [useNative]="!gridDragScrollEnabled" [scrollByContent]="gridDragScrollEnabled" [scrollByThumb]="gridDragScrollEnabled"></dxo-scrolling>
            <dxi-column dataField="task.name" caption="Task Name"></dxi-column>
            <dxi-column
              dataField="task.dueDate"
              caption="Due Date"
              dataType="date"
              format="MM/dd/yyyy"
            ></dxi-column>
            <dxi-column
              dataField="task.team"
              caption="Team"
            ></dxi-column>
            <dxi-column
              dataField="task.assignedUserName"
              caption="Assigned User"
            ></dxi-column>
          </dx-data-grid>

          <!-- Mobile (< 1024px) card view for previewed/generated tasks:
               read-only, vertically-stacked, no horizontal overflow. -->
          <div
            *ngIf="!isDesktopView"
            class="fandc-card-list"
            data-testid="fandc-generator-generated-card-list"
            role="list"
          >
            <div
              class="fandc-card"
              *ngFor="let gt of generatedTasks"
              [attr.data-testid]="'fandc-generator-generated-card-item'"
              role="listitem"
            >
              <div class="fandc-card__header">
                <span class="fandc-card__title" [title]="gt.task?.name">{{ gt.task?.name || 'Task' }}</span>
              </div>
              <dl class="fandc-card__body">
                <div class="fandc-card__field">
                  <dt class="fandc-card__label">Due Date</dt>
                  <dd class="fandc-card__value">{{ gt.task?.dueDate | date: 'MM/dd/yyyy' }}</dd>
                </div>
                <div class="fandc-card__field">
                  <dt class="fandc-card__label">Team</dt>
                  <dd class="fandc-card__value">{{ gt.task?.team }}</dd>
                </div>
                <div class="fandc-card__field">
                  <dt class="fandc-card__label">Assigned User</dt>
                  <dd class="fandc-card__value">{{ gt.task?.assignedUserName }}</dd>
                </div>
              </dl>
            </div>
          </div>

          <!-- <div *ngIf="isReviewBatch" data-testid="fandc-generator-action-buttons" class="action-buttons">
            <dx-form data-testid="fandc-generator-form-1">
              <dxi-item
                [colSpan]="1"
                cssClass="user-button detail-submit mb-1 mt-1"
                horizontalAlignment="right"
                editorType="dxButton"
                [editorOptions]="{
                  text: 'Create Tasks',
                  useSubmitBehavior: true,
                  validationGroup: 'formGroup',
                  cssClass: 'user-button mb-1 mt-1',
                  horizontalAlignment: 'right',
                  onClick: saveTasks.bind(this)
                }"
              ></dxi-item>
            </dx-form>
          </div> -->
    </div>
              <div data-testid="fandc-generator-action-buttons" class="action-buttons">
            <dx-form data-testid="fandc-generator-form-2">
              <dxi-item
                *ngIf="selectedPrototypeTasks && selectedPrototypeTasks.length > 0"
                cssClass="user-button detail-submit mb-1 mt-1"
                horizontalAlignment="right"
                editorType="dxButton"
                [editorOptions]="{
                  text: 'Save',
                  useSubmitBehavior: false,
                  validationGroup: 'formGroup',
                  cssClass: 'user-button mb-1 mt-1',
                  horizontalAlignment: 'right',
                  onClick: saveGenerationTask.bind(this),
                  disabled: !this.isLoanNumberPopulated || (this.lastPrototypeGenerateResult?.token ?? 0) < 1
                }"
              ></dxi-item>
            </dx-form>
          </div>
    </div>
    <dx-load-panel data-testid="fandc-generator-load-panel"
      [container]="'.fandc-generator-container'"
      [position]="{
        of: '.fandc-generator-container',
        at: 'center',
        my: 'center'
      }"
      [visible]="isLoadingLoanData || isGeneratingTasks || isSavingTasks || isLoadingMetadata || isSavingGenerationTask"
      [message]="isSavingGenerationTask ? 'Saving...' : 'Loading...'"
      [showPane]="true"
      [showIndicator]="true"
      [hideOnOutsideClick]="!isSavingGenerationTask"
    ></dx-load-panel>
    </dx-scroll-view>
</div>
